import { ITooltipParams } from '@ag-grid-community/core'
import { IssueCounts } from '@helios/generic-components'

export const issueTypeTooltipValueGetter = (params: ITooltipParams) => {
  if (params.data.accountType === 'aggregate') {
    return ''
  }
  if (params.value === '' || params.value == null) {
    return 'Accepted'
  } else {
    const { found, waiting } = params.value as IssueCounts
    const { count, type } = (() => {
      if (found?.high?.total)
        return {
          count: found.high.total,
          type: 'High',
        }
      if (found?.medium?.total)
        return {
          count: found.medium.total,
          type: 'Medium',
        }
      if (waiting?.high || waiting?.medium) {
        return {
          count: (waiting?.high?.total ?? 0) + (waiting?.medium?.total ?? 0),
          type: 'Held',
        }
      }
      return {
        count: undefined,
        type: 'Accepted',
      }
    })()

    return `${type}${count ? ` - ${count}` : ''}`
  }
}
